import React from 'react';
import { Upload, Trash2, CheckCircle } from 'lucide-react';
import { CloudUpload, DeleteIcon, DocIcon, GreenThick } from '../assets/icon';

interface DocumentUploadProps {
  label: string;
  description: string;
  files: File[];
  onChange: (files: File[]) => void;
  error?: string;
}

const DocumentUpload: React.FC<DocumentUploadProps> = ({
  label,
  description,
  files,
  onChange,
  error,
}) => {
  const hasFile = files.length > 0;

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(e.target.files || []);
    const validFiles = newFiles.filter(file => {
      if (file.size > 50 * 1024 * 1024) {
        alert(`${file.name} exceeds 50MB limit`);
        return false;
      }
      return true;
    });
    onChange(validFiles); // Replace, not append (matches your design)
  };

  const removeFile = () => {
    onChange([]);
  };

  return (
    <div className="space-y-4">
      {!hasFile ? (
        // Upload state
        <label className="block cursor-pointer">
          <input
            type="file"
            accept="image/*,.pdf"
            onChange={handleFileChange}
            className="hidden"
          />
          <div className="border border-gray-300 rounded-xl p-4 hover:border-gray-400 transition-colors">
            <div className="flex items-center justify-center gap-3 text-gray-600">
              <div className="bg-gray-200 border-2 border-dashed rounded-xl w-12 h-12 flex items-center justify-center">
                <DocIcon />
              </div>
              <div className="text-left">
                <p className="font-medium text-gray-900">{label}</p>
                <p className="text-sm text-gray-500">{description}</p>
              </div>
              <CloudUpload />
            </div>
          </div>
        </label>
      ) : (
        // Uploaded state
        <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
             <GreenThick />
              <div>
                <p className="font-medium text-gray-900">{label}</p>
                <p className="text-sm text-gray-600 truncate max-w-xs">
                  {files[0].name}
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={removeFile}
              className="text-gray-400 hover:text-red-600 transition-colors"
            >
              <DeleteIcon  />
            </button>
          </div>
        </div>
      )}

      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default DocumentUpload;